import { render } from "./ScanAcceptPackage.vue?vue&type=template&id=b37a63f4&scoped=true"
import script from "./ScanAcceptPackage.vue?vue&type=script&lang=js"
export * from "./ScanAcceptPackage.vue?vue&type=script&lang=js"

import "./ScanAcceptPackage.vue?vue&type=style&index=0&id=b37a63f4&scoped=true&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37a63f4"]])

export default __exports__